import axios from "axios";
import Nprogress from "nprogress";
import "nprogress/nprogress.css";
import qs from 'qs'
import store from "@/store"
import { ms, me, mi, mw } from "@/utils/elementUi"

import { VUE_APP_AJAX_BASE_URL, VUE_APP_AJAX_TIMEOUT } from "../../config"
import Cookies from "js-cookie";

// 配置axios
let myAxios = axios.create({
  // 所有不是http开头的url都会请求baseURL
  baseURL: VUE_APP_AJAX_BASE_URL,
  // 如果请求在指定毫秒里没返回就中断
  timeout: VUE_APP_AJAX_TIMEOUT
})

// 添加请求拦截器
myAxios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // Nprogress.start()

  //  所有接口给都传userId
  
  if (store.getters && store.getters.userId) {
    if(!config.data) config.data = {}
    config.data.userId = store.getters.userId
    config.data.token = store.getters.token
  }

  if (config.method != 'get') {
    config.data = qs.stringify(config.data);
  }
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  return config;
}, function (error) {
  // 对请求错误做些什么
  // Nprogress.done() 
  //$me("请求失败",error.message)
  return Promise.reject(error);
});

// 添加响应拦截器
myAxios.interceptors.response.use(function (response) {
  // 对响应数据做点什么

  // if (["false", "False"].includes(response.data.Success) && !response.data.Msg.includes("暂无数据")) {
  //   me(response.data.Msg)
  //   return Promise.reject(response.data.Msg);
  // }

  return response;
}, function (error) {
  // 对响应错误做点什么
  //$me("响应失败",error.message)
  return Promise.reject(error);
});

// 添加前缀
const urlPrefix = "tools.ashx?action="

export function $get(url, params) {
  url = urlPrefix + url
  return myAxios.get(url, { params })
}

export function $post(url, data, options = {}) {
  url = urlPrefix + url;
  if (options.responseType === 'arraybuffer') {
    return myAxios.post(url, data, options);
  } else {
    return myAxios.post(url, data);
  }
}
// export function $post(url, params) {
//   url = urlPrefix + url
//   return myAxios.post(url, {params})
// }

export function $axiosDelete(url, params) {
  url = urlPrefix + url
  return myAxios.delete(url, { params })
}

export function $put(url, params) {
  url = urlPrefix + url
  return myAxios.put(url, params)
}